import css from 'styled-jsx/css'
import { colors } from '../../../styles'

export default css`
.GuidanceDialog {
  text-align: center;
  max-width: 720px;
  line-height: 1;
}

.button-group {
  display: flex;
  margin: 2em auto;
  max-width: 300px;
  justify-content: space-between;
}

.parental-controls-info {
  font-size: 1.25rem;
  margin-bottom: 1.5em;
  margin-top: 1.5em;
  color: ${colors.tertiaryText};
  font-weight: lighter;
}
.parental-controls-link {
  font-weight: 800;
  font-size: 1.3em;
  color: ${colors.tertiaryText};
  text-transform: uppercase;
}

.parental-controls-link > :global(svg) {
  margin-top: -.2em;
  margin-right: 0.5em;
  vertical-align: middle;
}
`
